/**
 * Short form of a Stripe recurring interval, for pinning a cadence to an amount
 * ("$206.00/mo"). Both carts read the same value space — the platform's
 * `nextPaymentInterval` and a Stripe price's `interval` are both `"month"` / `"year"`.
 *
 * An interval with no short form returns "" rather than guessing: an amount with the
 * wrong cadence beside it is worse than a bare amount.
 */
export function intervalSuffix(interval: string | null | undefined): string {
  if (interval === "month") return "/mo";
  if (interval === "year") return "/yr";
  return "";
}
